import React from 'react';

const DataIntegrations: React.FC = () => (
  <div className="p-6">
    <h1 className="text-2xl font-bold text-gray-900 mb-4">
      Data & Integrations
    </h1>
    <p className="text-gray-600">Data & integrations coming soon...</p>
  </div>
);

export default DataIntegrations;
